var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReadyToCharge = function SvgReadyToCharge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9Zm0 16.2c3.978 0 7.2-3.222 7.2-7.2S15.978 4.8 12 4.8A7.198 7.198 0 0 0 4.8 12c0 3.978 3.222 7.2 7.2 7.2Zm3.182-11.655 1.273 1.273L12 13.273 10.727 12l4.455-4.455Z",
    fill: "#3D5F92"
  })));
};
export default SvgReadyToCharge;